import * as Contentstack from 'contentstack';
const Stack = Contentstack.Stack(
    process.env.REACT_APP_API_KEY,
    process.env.REACT_APP_DELIVERY_TOKEN,
    process.env.REACT_APP_ENVIRONMENT
);

export const getFooterContent = (store) => {
    let footer = {
        footer_status: 'INITIAL',
    };

    footer.footer_status = 'LOADING';
    store.setState({ footer });
    try {
        //footer query
        const footerQuery = Stack.ContentType('footer').Query();
        footerQuery
            .toJSON()
            .find()
            .then(
                function success(result) {
                    const footerData = result[0];
                    const isContentEmpty = footerData.length == 0;
                    footer = isContentEmpty ? footer : footerData[0];
                    footer.footer_status = isContentEmpty ? 'EMPTY' : 'SUCCESS';

                    store.setState({
                        footer,
                    });
                },
                function error(err) {
                    const isError404 =
                        error.response && error.response.status === 404;
                    const status = isError404 ? 'NOT_FOUND' : 'ERROR';
                    footer.footer_status = status;
                    store.setState({ footer });
                }
            );
    } catch (error) {
        store.setState({ status: 'ERROR`' });
    }
};
